import { useQuery } from '@tanstack/react-query';
import { ExtractFnReturnType } from '@/lib/react-query';
import { getConsolidationDataByType } from '@/features/dashboard/api/getConsolidationDataByType.ts';
import { TypesConsolidationData } from '@/types/ConsolidationData.ts';

type QueryFnType = typeof getConsolidationDataByType;

function useConsolidationScoreGeralAlunos(year?: number) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['fetch-consolidation-score-geral-alunos', year],
    queryFn: () => getConsolidationDataByType(TypesConsolidationData.SCORE_GERAL_ALUNOS, year ? String(year) : undefined),
  });
}

export { useConsolidationScoreGeralAlunos };
